const SEND_TO_EXPERTIZE_RES = "SEND_TO_EXPERTIZE_RES";
const SEND_TO_PUBLISH_RES = "SEND_TO_PUBLISH_RES";


const GET_SKILLALL_REQUEST = "GET_SKILLALL_REQUEST";
const GET_SKILLALL_COMPLETED = "GET_SKILLALL_COMPLETED";
const GET_SKILLALL_ERROR = "GET_SKILL_ERROR";

const GET_SKILL_AUTHORS_REQUEST = "GET_SKILL_AUTHORS_REQUEST";
const GET_SKILL_AUTHORS_COMPLETED = "GET_SKILL_AUTHORS_COMPLETED";
const GET_SKILL_AUTHORS_ERROR = "GET_SKILL_AUTHORS_ERROR";


const GET_SKILL_CARD_REQUEST = "GET_SKILL_CARD_REQUEST";
const GET_SKILL_CARD_COMPLETED = "GET_SKILL_CARD_COMPLETED";
const GET_SKILL_CARD_ERROR = "GET_SKILL_CARD_ERROR";

const GET_SKILL_REQUEST = "GET_SKILL_REQUEST";
const GET_SKILL_COMPLETED = "GET_SKILL_COMPLETED";
const GET_SKILL_ERROR  = "GET_SKILL_ERROR";

const GET_ORGANIZATIONS_REQUEST = "GET_ORGANIZATIONS_REQUEST";
const GET_ORGANIZATIONS_COMPLETED = "GET_ORGANIZATIONS_COMPLETED";
const GET_ORGANIZATIONS_ERROR = "GET_ORGANIZATIONS_ERROR";

const UPDATE_SKILL_REQUEST = "UPDATE_SKILL_REQUEST";
const UPDATE_SKILL_RESPONSE = "UPDATE_SKILL_RESPONSE";


const DELETE_SKILL_REQUEST = "DELETE_SKILL_REQUEST";
const DELETE_SKILL_COMPLETED = "DELETE_SKILL_COMPLETED";
const DELETE_SKILL_ERROR = "DELETE_SKILL_ERROR";


const CHANGE_UPDATE_DATA = "CHANGE_UPDATE_DATA";
const GET_WORLDSKILL_ALL = "GET_WORLDSKILL_ALL";

const GET_MODULE_LIST_REQUEST = "GET_MODULE_LIST_REQUEST";
const GET_MODULE_LIST_COMPLETED = "GET_MODULE_LIST_COMPLETED";
const GET_MODULE_LIST_ERROR = "GET_MODULE_LIST_ERROR";

const CREATE_MODULE_LIST_REQUEST = "CREATE_MODULE_LIST_REQUEST";
const CREATE_MODULE_LIST_ERROR = "CREATE_MODULE_LIST_ERROR";

const UPDATE_MODULE_REQUEST = "UPDATE_MODULE_REQUEST";
const UPDATE_MODULE_RESPONSE = "UPDATE_MODULE_RESPONSE";

const DELETE_MODULE_REQUEST = "DELETE_MODULE_REQUEST";
const DELETE_MODULE_RESPONSE = "DELETE_MODULE_RESPONSE";



const CREATE_SCALE_REQUEST = "CREATE_SCALE_REQUEST";
const CREATE_SCALE_RESPONSE = "CREATE_SCALE_RESPONSE";

const UPDATE_SCALE_REQUEST = "UPDATE_SCALE_REQUEST";
const UPDATE_SCALE_RESPONSE = "UPDATE_SCALE_RESPONSE";

const DELETE_SCALE_REQUEST = "DELETE_SCALE_REQUEST";
const DELETE_SCALE_RESPONSE = "DELETE_SCALE_RESPONSE";





const CREATE_RATE_REQUEST = "CREATE_RATE_REQUEST";
const CREATE_RATE_RESPONSE = "CREATE_RATE_RESPONSE";

const UPDATE_RATE_REQUEST = "UPDATE_RATE_REQUEST";
const UPDATE_RATE_RESPONSE = "UPDATE_RATE_RESPONSE";

const DELETE_RATE_REQUEST = "DELETE_RATE_REQUEST";
const DELETE_RATE_RESPONSE = "DELETE_RATE_RESPONSE";





const GET_ROOMS_REQUEST = 'GET_ROOMS_REQUEST';
const GET_ROOMS_COMPLETED = 'GET_ROOMS_COMPLETED';
const GET_ROOMS_ERROR = 'GET_ROOMS_ERROR';

const CREATE_ROOMS_REQUEST = 'CREATE_ROOMS_REQUEST';
const CREATE_ROOMS_RESPONSE = 'CREATE_ROOMS_RESPONSE';

const UPDATE_ROOMS_REQUEST = 'UPDATE_ROOMS_REQUEST';
const UPDATE_ROOMS_RESPONSE = 'UPDATE_ROOMS_RESPONSE';

const DELETE_ROOMS_REQUEST = 'DELETE_ROOMS_REQUEST';
const DELETE_ROOMS_RESPONSE = 'DELETE_ROOMS_RESPONSE';

const CREATE_RESOURCE_REQUEST = 'CREATE_RESOURCE_REQUEST';
const CREATE_RESOURCE_RESPONSE = 'CREATE_RESOURCE_RESPONSE';

const UPDATE_RESOURCE_REQUEST = 'UPDATE_RESOURCE_REQUEST';
const UPDATE_RESOURCE_RESPONSE = 'UPDATE_RESOURCE_RESPONSE';

const DELETE_RESOURCE_REQUEST = 'DELETE_RESOURCE_REQUEST';
const DELETE_RESOURCE_RESPONSE = 'DELETE_RESOURCE_RESPONSE';


export default {
    SEND_TO_EXPERTIZE_RES,
    SEND_TO_PUBLISH_RES,

    GET_SKILLALL_REQUEST,
    GET_SKILLALL_COMPLETED,
    GET_SKILLALL_ERROR,

    GET_SKILL_AUTHORS_REQUEST,
    GET_SKILL_AUTHORS_COMPLETED,
    GET_SKILL_AUTHORS_ERROR,

    GET_SKILL_REQUEST,
    GET_SKILL_COMPLETED,
    GET_SKILL_ERROR,

    UPDATE_SKILL_REQUEST,
    UPDATE_SKILL_RESPONSE,

    GET_SKILL_CARD_REQUEST,
    GET_SKILL_CARD_COMPLETED,
    GET_SKILL_CARD_ERROR,

    DELETE_SKILL_REQUEST,
    DELETE_SKILL_COMPLETED,
    DELETE_SKILL_ERROR,

    CHANGE_UPDATE_DATA,
    GET_WORLDSKILL_ALL,

    GET_MODULE_LIST_REQUEST,
    GET_MODULE_LIST_COMPLETED,
    GET_MODULE_LIST_ERROR,

    CREATE_MODULE_LIST_REQUEST,
    CREATE_MODULE_LIST_ERROR,

    UPDATE_MODULE_REQUEST,
    UPDATE_MODULE_RESPONSE,

    DELETE_MODULE_REQUEST,
    DELETE_MODULE_RESPONSE,

    CREATE_SCALE_REQUEST,
    CREATE_SCALE_RESPONSE,

    UPDATE_SCALE_REQUEST,
    UPDATE_SCALE_RESPONSE,

    DELETE_SCALE_REQUEST,
    DELETE_SCALE_RESPONSE,


    CREATE_RATE_REQUEST,
    CREATE_RATE_RESPONSE,

    UPDATE_RATE_REQUEST,
    UPDATE_RATE_RESPONSE,

    DELETE_RATE_REQUEST,
    DELETE_RATE_RESPONSE,


    GET_ROOMS_REQUEST,
    GET_ROOMS_COMPLETED,
    GET_ROOMS_ERROR,

    CREATE_ROOMS_REQUEST,
    CREATE_ROOMS_RESPONSE,

    UPDATE_ROOMS_REQUEST,
    UPDATE_ROOMS_RESPONSE,

    DELETE_ROOMS_REQUEST,
    DELETE_ROOMS_RESPONSE,

    CREATE_RESOURCE_REQUEST,
    CREATE_RESOURCE_RESPONSE,

    UPDATE_RESOURCE_REQUEST,
    UPDATE_RESOURCE_RESPONSE,

    DELETE_RESOURCE_REQUEST,
    DELETE_RESOURCE_RESPONSE,

    GET_ORGANIZATIONS_REQUEST,
    GET_ORGANIZATIONS_COMPLETED,
    GET_ORGANIZATIONS_ERROR,
}
